export const shouldShowConsolidatedEditAlert = (canSubmit: boolean | undefined): boolean => canSubmit === false
